//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PopupCard from "@/pages/Sellers/components/PopupCard.vue";

const DEFAULT_FORMAT = value => (value ? value : "N/A");

export default {
  name: "TeamsTable",
  props: ["tableClass", "bordered", "recordsTotal", "loading", "data"],
  components: {
    PopupCard
  },
  mounted: function() {
    for (let i = 0; i < this.data.length; i++) {
      this.areaPopup.push(false);
      this.storePopup.push(false);
      this.sellerPopup.push(false);
      this.routePopup.push(false);
      this.supervisorPopup.push(false);
      this.promoterPopup.push(false);
      this.repositorPopup.push(false);
      this.salesDirectorPopup.push(false);
    }
  },
  data: () => ({
    filter: "",
    separator: "horizontal",
    pagination: {
      page: 1,
      rowsPerPage: 8,
      rowsNumber: 0
    },
    columns: [
      {
        name: "name",
        required: true,
        label: "Nome",
        align: "left",
        field: row => row.name,
        format: DEFAULT_FORMAT,
        sortable: true
      }
    ],
    areaPopup: [],
    storePopup: [],
    sellerPopup: [],
    routePopup: [],
    supervisorPopup: [],
    promoterPopup: [],
    repositorPopup: [],
    salesDirectorPopup: [],
    isClicked: [],
    lastSelectedItemPage: null,
    lastSelectedItemRow: null
  }),
  methods: {
    fetchRowData: function(index) {
      let indexOnLine = index % this.pagination.rowsPerPage;
      let data = this.data[indexOnLine];
      this.isClicked = Array(this.data.length).fill(false);
      this.isClicked.splice(indexOnLine, 1, true);
      this.lastSelectedItemPage = this.pagination.page;
      this.lastSelectedItemRow = indexOnLine;
      this.$emit("clicked-row", data);
    },
    updateState: function(event) {
      this.pagination = event.pagination;
      this.$emit("request-new-page", event);
    },
    expandArea: function(row, state) {
      this.areaPopup.splice(row, 1, state);
    },
    expandStore: function(row, state) {
      this.storePopup.splice(row, 1, state);
    },
    expandSeller: function(row, state) {
      this.sellerPopup.splice(row, 1, state);
    },
    expandRoute: function(row, state) {
      this.routePopup.splice(row, 1, state);
    },
    expandSupervisor: function(row, state) {
      this.supervisorPopup.splice(row, 1, state);
    },
    expandPromoter: function(row, state) {
      this.promoterPopup.splice(row, 1, state);
    },
    expandRepositor: function(row, state) {
      this.repositorPopup.splice(row, 1, state);
    },
    expandSalesDirector: function(row, state) {
      this.salesDirectorPopup.splice(row, 1, state);
    }
  },
  watch: {
    recordsTotal: {
      immediate: true,
      handler: function(newVal) {
        // watch it
        this.pagination.rowsNumber = newVal;
      }
    }
  }
};
